import http from '../../baseUrl/HttpCommon';
import authHeader from '../authHeader/AuthHeader';

const getCGeneration = (CompanyId) => {
  console.log('getCGeneration CompanyId', CompanyId);
  return http.get(`/C3/GetC3Reports/${CompanyId}`, {
    headers: authHeader(),
  });
};

const loadEmployee = (data) => {
  console.log('loadEmployee load ', data.dataLoad);
  return http.post(
    `/C3/LoadEmployee?CompanyId=${data.CompanyId}&monthno=${data.month}&Year=${data.year}`,
    data.dataLoad,
    {
      headers: authHeader(),
    },
  );
};

const previewApi = (data) => {
  console.log('previewApi load ', data);
  return http.post(`/C3/SaveNContinue?`, data, {
    headers: authHeader(),
  });
};

// const editC3EmployeeListingApi = (data) => {
//   return http.get(
//     `/C3/EditC3EmployeeListing?headerId=${data.headerId}&CompanyId=${
//       data.CompanyId
//     }&popUpList=${encodeURIComponent(JSON.stringify(data.popUpList))}`,
//     {
//       headers: authHeader(),
//     },
//   );
// };

const editC3EmployeeListingApi = (data) => {
  return http.post(
    `/C3/EditC3EmployeeListing`,
    {
      headerId: data.headerId,
      CompanyId: data.CompanyId,
      popUpList: data.popUpList, // Sent in body, not in URL
    },
    {
      headers: authHeader(),
    },
  );
};

const deleteCGeneration = (headerId) => {
  return http.get(`/C3/DeleteC3?headerId=${headerId}`, {
    headers: authHeader(),
  });
};

const submitC3 = (data) => {
  console.log('submitC3 data', data);
  return http.post(
    `/C3/SubmitC3Bulk?headerId=${data.headerID}&CompanyId=${data.CompanyId}&UserID=${data.UserID}`,
    null,
    {
      headers: authHeader(),
    },
  );
};

const checkC3Created = (data) => {
  return http.get(
    `/C3/check_C3Created?Year=${data.year}&Month=${data.month}&CompanyId=${data.CompanyId}`,
    {
      headers: authHeader(),
    },
  );
};

const addOrUpdateSaveNContinue = (data) => {
  return http.post(`/C3/AddOrUpdateSaveNContinue`, data, {
    headers: authHeader(),
  });
};

const CGenerationService = {
  getCGeneration,
  loadEmployee,
  previewApi,
  editC3EmployeeListingApi,
  deleteCGeneration,
  submitC3,
  checkC3Created,
  addOrUpdateSaveNContinue,
};

export default CGenerationService;
